/** Tooltip copy for Course settings labels — presentation only. */
export const COURSE_SETTINGS_FIELD_HELP = {
  courseEnabled: 'When off, the course is disabled and not available to learners. Turn on to make it active again.',
  startDate: 'First day learners can access this course. Before this date enrollment may be blocked.',
  endDate: 'Last day the course is available. After this date learners lose access.',
  level: 'Difficulty tier for this course (for example 1–5). Used for filtering and Yaki generation context.',
  expiresInDays: 'How many days each learner has to complete the course after they enroll — separate from the end date.',
  inAppPurchase: 'When on, learners pay through the app before enrolling. Requires Stripe setup.',
  price: 'Amount charged per learner when in-app purchase is enabled.',
  useForRegisterStudents: 'Enables the public registration link so new learners can self-enroll with an access code.',
  accessCode: 'Five-character code learners enter on the registration page to join this course.',
  autoRegister: 'When on, learners who register with the access code are enrolled automatically without manual approval.',
};
